import { render, staticRenderFns } from "./DataShare.vue?vue&type=template&id=aba80ca8&"
import script from "./DataShare.vue?vue&type=script&lang=js&"
export * from "./DataShare.vue?vue&type=script&lang=js&"
import style0 from "./DataShare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports